<script>
export default {
  name: "MessageDialog",

  data: () => ({
    title: "",
    subTitle: "",
    text: "",

    showDialog: false,
  }),

  computed: {
    messageDialog() {
      return this.$store.getters["getMessageDialog"];
    },
  },

  watch: {
    messageDialog() {
      this.showDialog = !!this.messageDialog;

      if (!this.messageDialog) {
        this.type = "message";
        return;
      }

      const { text, title, subTitle } = this.messageDialog;

      this.text = text;
      this.title = title;
      this.subTitle = subTitle;
    },
  },

  methods: {
    closeDialog() {
      this.$emit("close");
      this.$store.dispatch("hideMessageDialog", null);
    },
  },
};
</script>

<template>
  <v-dialog
    v-if="showDialog"
    v-model="showDialog"
    hide-overlay
    no-click-animation
    persistent
    max-width="270px"
    content-class="fixed-right alert-container message-dialog rounded-borders-5"
    @keydown.esc="closeDialog()"
  >
    <v-card
      class="rounded-borders-5 d-flex flex-column justify-center align-center position-relative"
      @click="closeDialog()"
    >
      <v-card-title v-if="title" class="justify-center pt-2 pb-0">
        <span
          style="line-height: 24px"
          class="white--text font-size-16 font-weight-bold"
        >
          {{ title }}
        </span>
      </v-card-title>
      <v-card-text
        :style="{
          'padding-top': title ? '0 !important' : 'inherit',
        }"
        :class="{
          'py-3': !title,
        }"
        class="white--text text-center font-size-14 font-weight-semi pb-2"
      >
        {{ text }}
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
.alert-container {
  filter: drop-shadow(1px 1px 5px #000000);
  position: absolute;
  top: 32px;
  left: 0;
  z-index: 9999;
}
</style>
